<script setup lang="ts">
import { Head, router } from "@inertiajs/vue3"
import { ref, useTemplateRef } from "vue"
import { z } from "zod"

import FlashAlerts from "@/components/FlashAlerts.vue"
import { profilePasswordPath, profilePath } from "@/routes"

const loading = ref(false)
const authFormRef = useTemplateRef("authFormRef")

const schema = z
  .object({
    current_password: z.string().min(1, "Current password is required"),
    password: z.string().min(8, "Password must be at least 8 characters"),
    password_confirmation: z.string().min(1, "Please confirm your password"),
  })
  .refine((data) => data.password === data.password_confirmation, {
    message: "Passwords don't match",
    path: ["password_confirmation"],
  })

function submit() {
  if (!authFormRef.value) return
  loading.value = true
  router.patch(profilePasswordPath(), authFormRef.value.state, {
    onFinish: () => {
      loading.value = false
    },
  })
}
</script>

<template>
  <Head title="Change Password" />
  <div class="mx-auto max-w-sm py-8">
    <UAuthForm
      ref="authFormRef"
      title="Change your password"
      :schema="schema"
      :fields="[
        {
          name: 'current_password',
          label: 'Current Password',
          type: 'password',
          required: true,
          autocomplete: 'current-password',
        },
        {
          name: 'password',
          label: 'New Password',
          type: 'password',
          required: true,
          autocomplete: 'new-password',
        },
        {
          name: 'password_confirmation',
          label: 'Confirm New Password',
          type: 'password',
          required: true,
          autocomplete: 'new-password',
        },
      ]"
      :loading="loading"
      :submit="{ label: 'Update Password' }"
      @submit="submit"
    >
      <template #validation>
        <FlashAlerts />
      </template>

      <template #footer>
        <UButton :to="profilePath()" variant="link" label="Cancel" class="text-muted" />
      </template>
    </UAuthForm>
  </div>
</template>
